/**
 * CookieConsent
 * Cookie使用の同意バナー。MTG：「同意する」のみ（「同意しない」は不要）。
 * 「同意する」を押すと N 日間バナーを表示しない（Cookieの有効期限で制御）。
 *
 * ◆ 非表示にする日数の変更方法（ここだけ変えればOK）
 *   - 既定は EXPIRE_DAYS（下の定数）。
 *   - 個別に変えたい場合は生成時に渡す: new CookieConsent({ expireDays: 60 });
 *
 * 仕組み：
 *   - 同意時に Cookie（max-age = 日数）を保存。Cookieが有効な間はバナーを表示しない。
 *   - 日数が過ぎて Cookie が消えると、次回アクセスで再表示される。
 *   - 未同意（Cookieなし）のときだけ .is-active を付与して表示する（同意済みは表示しない）。
 *
 * @usage JS: new CookieConsent();  ／ HTML: .js-cookie（本体）, .js-cookie-accept（同意ボタン）
 */

// ★ 同意後にバナーを表示しない日数（ここを変更すれば変わる）
const EXPIRE_DAYS = 30;

export default class CookieConsent {
  constructor(options = {}) {
    this.options = {
      rootSelector: '.js-cookie',
      acceptSelector: '.js-cookie-accept',
      activeClass: 'is-active',
      cookieName: 'forcle_cookie_consent',
      expireDays: EXPIRE_DAYS,
      ...options,
    };

    this.root = document.querySelector(this.options.rootSelector);
    if (!this.root) return;

    this.acceptBtn = this.root.querySelector(this.options.acceptSelector);

    this.init();
  }

  init() {
    // 同意済み（Cookieが有効）なら何もしない＝表示しない
    if (this.hasConsent()) return;

    this.show();

    if (this.acceptBtn) {
      this.acceptBtn.addEventListener('click', () => this.accept());
    }
  }

  hasConsent() {
    return this.getCookie(this.options.cookieName) === '1';
  }

  accept() {
    this.setCookie(this.options.cookieName, '1', this.options.expireDays);
    this.hide();
  }

  show() {
    this.root.classList.add(this.options.activeClass);
  }

  hide() {
    this.root.classList.remove(this.options.activeClass);
  }

  getCookie(name) {
    const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  setCookie(name, value, days) {
    const maxAge = Math.max(0, Math.floor(days * 24 * 60 * 60)); // 日 → 秒
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; SameSite=Lax`;
  }
}
